import { oktaTokenBaseQuery } from "@/react/services/api";
import { HttpMethods } from "@/react/http";
import { createApi } from "@reduxjs/toolkit/query/react";

const GLOBAL_DIALPLANS = Object.freeze("GLOBAL_DIALPLANS");
const BASE_URL = Object.freeze("/v1/dialplans");

export const globalDialplansApi = createApi({
  reducerPath: "globalDialplansApi",
  baseQuery: oktaTokenBaseQuery(),
  endpoints: (build) => ({
    getGlobalDialplans: build.query({
      query: () => ({
        method: HttpMethods.GET,
        url: BASE_URL,
      }),
      // Some ID is required to check for name uniqueness when creating a new Dial Plan
      // For simplicity, since name is unique already, setting an ID equal to name
      transformResponse: (response) =>
        response.map((dialplan) => ({ id: dialplan.name, ...dialplan })),
      providesTags: [GLOBAL_DIALPLANS],
    }),
    createGlobalDialplan: build.mutation({
      query: ({ dialplan }) => ({
        method: HttpMethods.POST,
        url: BASE_URL,
        body: dialplan,
      }),
      invalidatesTags: [GLOBAL_DIALPLANS],
    }),
    updateGlobalDialplan: build.mutation({
      query: ({ dialplan }) => ({
        method: HttpMethods.PUT,
        url: BASE_URL,
        body: dialplan,
      }),
      invalidatesTags: [GLOBAL_DIALPLANS],
    }),
  }),
});

export const {
  useLazyGetGlobalDialplansQuery,
  useCreateGlobalDialplanMutation,
  useUpdateGlobalDialplanMutation,
} = globalDialplansApi;
